<template>
  <v-bottom-navigation
    v-if="type"
    color="primary lighten-1"
    class="d-xl-none d-lg-none d-md-none"
    app
    grow
  >
    <v-btn :to="item.path" v-for="item in menuItems" :key="item.title">
      <span>{{ item.title }}</span>
      <v-icon>{{ item.icon }}</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
export default {
  name: 'BottomNavigation',
  props: {
    type: Boolean,
  },
  data() {
    return {
      menuItems: [
        { title: 'Home', path: '/', icon: 'home' },
        { title: 'Explore', path: '/semua-event', icon: 'explore' },
        { title: 'My Ticket', path: '/my-ticket', icon: 'local_activity' },
        { title: 'Account', path: '/my-account', icon: 'face' },
      ],
    };
  },
};
</script>

<style scoped></style>
